/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_CategoriesInputs */

const en_footer_link_categories = /** @type {(inputs: Footer_Link_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categories`)
};

const es_footer_link_categories = /** @type {(inputs: Footer_Link_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorías`)
};

const fr_footer_link_categories = /** @type {(inputs: Footer_Link_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégories`)
};

const de_footer_link_categories = /** @type {(inputs: Footer_Link_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorien`)
};

const ja_footer_link_categories = /** @type {(inputs: Footer_Link_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カテゴリ`)
};

const zh_footer_link_categories = /** @type {(inputs: Footer_Link_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部分类`)
};

const ar_footer_link_categories = /** @type {(inputs: Footer_Link_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفئات`)
};

const id_footer_link_categories = /** @type {(inputs: Footer_Link_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori`)
};

const it_footer_link_categories = /** @type {(inputs: Footer_Link_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorie`)
};

const ru_footer_link_categories = /** @type {(inputs: Footer_Link_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категории`)
};

const pt_footer_link_categories = /** @type {(inputs: Footer_Link_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorias`)
};

const ko_footer_link_categories = /** @type {(inputs: Footer_Link_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카테고리`)
};

/**
* | output |
* | --- |
* | "Categories" |
*
* @param {Footer_Link_CategoriesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_link_categories = /** @type {((inputs?: Footer_Link_CategoriesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_CategoriesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_link_categories(inputs)
	if (locale === "es") return es_footer_link_categories(inputs)
	if (locale === "fr") return fr_footer_link_categories(inputs)
	if (locale === "de") return de_footer_link_categories(inputs)
	if (locale === "ja") return ja_footer_link_categories(inputs)
	if (locale === "zh") return zh_footer_link_categories(inputs)
	if (locale === "ar") return ar_footer_link_categories(inputs)
	if (locale === "id") return id_footer_link_categories(inputs)
	if (locale === "it") return it_footer_link_categories(inputs)
	if (locale === "ru") return ru_footer_link_categories(inputs)
	if (locale === "pt") return pt_footer_link_categories(inputs)
	return ko_footer_link_categories(inputs)
});